import React, { memo, useState } from 'react'
import "../../../styles/multipliers-styles.scss"
import ProductMutiplierModal from "./ProductMultiplierModel/ProductMultiplierModal"
import LoadingSkeleton from './LoadingSkeleton'
import MultiplierInput from 'components/Multipliers/MultiplierInput'
import { Table } from 'react-bootstrap'


function FormProductMultiplierTable(props) {
    const { products, loading, updateMultiplier, updateMultiplierSipping, multipliers, globleMultiplier = {} } = props
    const [show, setShow] = useState(false)
    const [selected, setSelected] = useState(null)
    const [multiplier_, setMultiplier] = useState(null)
    const { brand_multiplier = 0, category_multiplier = 0, credit_card_fee = 0, product_multiplier = 0 } = globleMultiplier
    const globleMultip = product_multiplier || category_multiplier || brand_multiplier
    return (
        <div id="app-product-multiplier-table">
            {show && <ProductMutiplierModal
                show={show}
                product={selected}
                globleMultiplier={globleMultiplier}
                multiplier={multiplier_}
                closeModal={() => {
                    setShow(false)
                }}
            />}
            < Table className="mb-0 product-multiplier-table">
                <thead className="border-bottom st-border-light product-multiplier-table-head">
                    <tr>
                        <th className="column__sku" >
                            <p className="text-capitalize">
                                SKU
                            </p>

                        </th>
                        {props.column__costPrice &&
                            <th className="column__costPrice">
                                <p className="text-capitalize">
                                    Cost Price
                                </p>
                            </th>
                        }
                        {props.column__brandMultiplier &&
                            <th className="column__brandMultiplier">
                                <p className="text-capitalize">
                                    Brand Multiplier
                                </p>
                            </th>
                        }
                        {props.column__categoryMultiplier &&
                            <th className="column__categoryMultiplier">
                                <p className="text-capitalize">
                                    Category Multiplier
                                </p>
                            </th>
                        }

                        {props.column__productMultiplier &&
                            <th className="column__productMultiplier">
                                <p className="text-capitalize">
                                    Products Multiplier
                                </p>
                            </th>
                        }

                        {props.column__shippingMultiplier &&
                            <th className="column__shippingMultiplier">
                                <p className="text-capitalize">
                                    shipping multiplier
                                </p>
                            </th>
                        }
                        {props.column__creditCardFee &&
                            <th className="column__creditCardFee">
                                <p className="text-capitalize">
                                    credit card fee
                                </p>
                            </th>

                        }
                        {props.column__misc &&
                            <th className="column__misc">
                                <p className="text-capitalize">
                                    misc.
                                </p>
                            </th>
                        }
                        {props.column__totalPrice &&
                            <th className="column__totalPrice">
                                <p className="text-capitalize">
                                    Price($)
                                </p>
                            </th>
                        }
                        {props.column__totalProfit &&
                            <th className="column__totalProfit">
                                <p className="text-capitalize">
                                    Profit($)
                                </p>
                            </th>
                        }
                    </tr>
                </thead>

                <tbody className="product-multiplier-table-body">
                    {loading ? <tr><td colSpan={12}><LoadingSkeleton /></td></tr> :
                        (products && products.length) ? products.map((item, index) => {
                            const multiplier = multipliers.find(e => parseInt(e.product_id) === parseInt(item.product_id)) || {}
                            const price = (((item.cost_price || 0) * (multiplier.multiplier || globleMultip)) * (1 + ((multiplier.shipping_multiplier || 0) / 100)) * (1 + ((item.credit_card_fee || credit_card_fee) / 100))).toFixed(2)
                            const profit = (price - (item.cost_price || 0)).toFixed(2)
                            return (<tr className="" key={index}>
                                <td className="column__sku">
                                    <div className="text-uppercase">
                                        {item.product_name}
                                    </div>
                                    <p className="text-captialize">
                                        {item.sku}
                                    </p>
                                </td>

                                {props.column__costPrice &&
                                    <td className="column__costPrice">
                                        {/* <MultiplierInput
                                            id={item.cost_price}
                                            multiplier={item.cost_price}
                                            onChange={() => {
                                            }} /> */}
                                        <p>
                                            {item.cost_price}
                                        </p>
                                    </td>
                                }
                                {props.column__brandMultiplier &&
                                    <td className="column__brandMultiplier">
                                        <p className="text-uppercase">
                                            {brand_multiplier}
                                        </p>
                                    </td>
                                }
                                {props.column__categoryMultiplier &&
                                    <td className="column__categoryMultiplier">
                                        <p className="">
                                            {category_multiplier}
                                        </p>
                                    </td>
                                }
                                {props.column__productMultiplier &&
                                    <td className="column__productMultiplier">
                                        <MultiplierInput
                                            id={item.product_id}
                                            multiplier={multiplier.multiplier}
                                            multiplierType={multiplier.multiplier_type}
                                            onChange={updateMultiplier}
                                        />
                                    </td>
                                }
                                {props.column__shippingMultiplier &&
                                    <td className="column__shippingMultiplier">
                                        <MultiplierInput
                                            id={item.product_id}
                                            multiplier={multiplier.shipping_multiplier}
                                            multiplierType={multiplier.shipping_multiplier_type}
                                            onChange={updateMultiplierSipping}

                                        />
                                    </td>
                                }
                                {props.column__creditCardFee &&
                                    <td className="column__creditCardFee">
                                        <p className="">
                                            {credit_card_fee}
                                        </p>
                                    </td>
                                }
                                {props.column__misc &&
                                    <td className="column__misc">
                                        <p className="">
                                            0
                                        </p>
                                    </td>
                                }
                                {props.column__totalPrice &&
                                    <td className="column__totalPrice"
                                        onClick={() => {
                                            setShow(true)
                                            setSelected(item)
                                            setMultiplier(multiplier)
                                        }}
                                    >
                                        <p className="column_totalPrice">
                                            {price}
                                        </p>
                                    </td>
                                }
                                {props.column__totalProfit &&
                                    <td className="column__totalProfit">
                                        <p className="">
                                            {profit}
                                        </p>
                                    </td>
                                }
                            </tr>
                            )
                        }) : (
                            <tr>
                                <td colSpan="12">
                                    <p className="no-data-found text-center st-fw-700 py-1">
                                        No data found
                                    </p>
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </Table>
        </div >
    )
}

export default memo(FormProductMultiplierTable)
